angular
.module("avant.customer_applications.directives")
.directive('genericReassurance', ->
  return{
    scope:true
    restrict: 'A',
    templateUrl: '/customer_application_renderer/components/declined/partner_offer/generic_reassurance.html'
  }
)
